import React from "react";
import { Button, Col, Form, Image, Modal, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import FileDropZone from "../sub/FileDropZone";
import { connect } from "react-redux";
import {
  addProduct,
  addProductDocuments,
  addProductImage,
  deleteProductDocument,
  isProductKeywordAlreadyExists,
  updateProduct,
} from "../../actions/imagedatabase/products";
import APIUrl from "../../APIUrl";
import Icon from "../sub/Icon";
import KeywordModal from "./KeywordModal";
import ConfirmationModal from "../sub/modals/ConfirmationModal";
import Notification from "../sub/Notification";
import MenuButton from "../sub/bootstrap/MenuButton";
import UploadImgModal from "./UploadImgModal";

class ProductModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      manufacturer: this.props.product ? this.props.product.manufacturer : "",
      supplier: this.props.product ? this.props.product.supplier : "",
      designation: this.props.product ? this.props.product.designation : "",
      description: this.props.product ? this.props.product.description : "",
      lppCode: this.props.product ? this.props.product.lpp_code : "",
      lppAmount: this.props.product ? this.props.product.lpp_amount : "",
      keyword: "",
      keywords: this.props.product ? this.props.product.keywords : [],
      documents: this.props.product ? this.props.product.documents : [],
      keywordError: "",
      documentsError: "",
      file: null,
      docFiles: [],
    };
  }

  isKeywordAlreadyExists(keyword) {
    if (!keyword) return this.setState({ keywordError: "" });

    this.props.onGetIsProductKeywordAlreadyExists(
      keyword.toUpperCase(),
      () =>
        this.setState({
          keywordError: <FormattedMessage id="Keyword.Already.Exists" />,
        }),
      () => this.setState({ keywordError: "" }),
    );
  }

  closeModal() {
    this.setState({ modal: null });
  }

  addKeyword(newkeyword) {
    const updatedKeywords = [...this.state.keywords, newkeyword];
    this.setState({ keyword: "", keywords: updatedKeywords });
  }

  updateKeyword(oldKeyword, newkeyword) {
    const updatedKeywords = this.state.keywords
      .filter((k) => k !== oldKeyword)
      .concat(newkeyword);
    this.setState({ keywords: updatedKeywords });
  }

  deleteKeyword(keyword) {
    const updatedKeywords = this.state.keywords.filter((k) => k !== keyword);
    this.setState({ keywords: updatedKeywords });
  }

  deleteDocument(document) {
    const updatedDocuments = this.state.documents.filter(
      (d) => d.file_name !== document.file_name,
    );
    this.setState({ documents: updatedDocuments });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openKeywordModal(keyword) {
    this.setState({
      modal: (
        <KeywordModal
          imageType={"product"}
          keyword={keyword}
          add={(newKeyword) => this.addKeyword(newKeyword)}
          update={(newKeyword) => this.updateKeyword(keyword, newKeyword)}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  uploadImg(productId, img) {
    const successCallback = () => {
      Notification({
        type: "success",
        description: this.props.intl.formatMessage({
          id: "Image.Add.Success",
        }),
      });

      this.props.fetchProducts();
      this.props.closeModal();
    };
    let formData = new FormData();
    formData.append(img.name, img);

    this.props.onAddProductImage(productId, formData, successCallback);
  }

  uploadDocuments(product, files) {
    const successCallback = () => {
      this.props.fetchProducts();
      this.props.closeModal();
    };
    let formData = new FormData();

    files.forEach((file, index) => {
      const fileName = `file${product.documents.length - files.length + index + 1}`;
      formData.append(fileName, file);
    });

    this.props.onAddProductDocuments(product._id, formData, successCallback);
  }

  onDropFiles(files) {
    let documents = [...this.state.documents];
    let docFiles = [...this.state.docFiles];

    for (let file of files) {
      documents.push({
        file_name: file.name,
        file_extension: file.name.split(".").pop(),
        file_size: file.size,
      });

      docFiles.push(file);
    }

    this.setState({ docFiles: docFiles, documents: documents });
  }

  addProduct() {
    let product = {
      manufacturer: this.state.manufacturer,
      supplier: this.state.supplier,
      designation: this.state.designation,
      description: this.state.description,
      lpp_code: this.state.lppCode,
      lpp_amount: this.state.lppAmount,
      keywords: this.state.keywords,
      documents: this.state.documents,
    };

    if (this.props.product) {
      product._id = this.props.product._id;
      return this.props.onUpdateProduct(product, () => {
        if (this.state.file && this.state.file.length !== 0) {
          this.uploadImg(product._id, this.state.file[0]);
        }

        if (this.state.docFiles && this.state.docFiles.length !== 0) {
          return this.uploadDocuments(product, this.state.docFiles);
        }

        if (this.state.documents !== this.props.product.documents) {
          const removedDocuments = this.props.product.documents.filter(
            (doc) =>
              !this.state.documents.some(
                (stateDoc) => stateDoc._id === doc._id,
              ),
          );

          if (removedDocuments.length > 0) {
            removedDocuments.forEach((doc) => {
              this.props.onDeleteProductDocument(doc._id);
            });
          }
        }

        this.props.fetchProducts();
        this.props.closeModal();
      });
    }

    this.props.onAddProduct(product, (p) => {
      if (this.state.documents.length !== 0) {
        this.uploadDocuments(p, this.state.docFiles);
      }
      this.uploadImg(p._id, this.state.file);
    });
  }

  openImgModal(currentImage) {
    const onComplete = (newImage) => {
      this.setState({ file: newImage }, () => this.closeModal());
    };

    this.setState({
      modal: (
        <UploadImgModal
          closeModal={() => this.closeModal()}
          currentImage={currentImage}
          onComplete={onComplete}
        />
      ),
    });
  }

  render() {
    const { product } = this.props;

    let currentImage = null;

    if (product) {
      currentImage = this.state.file
        ? URL.createObjectURL(this.state.file[0])
        : `${APIUrl.getProductImg}${product._id}/?token=${APIUrl.jwtToken}`;
    }

    return (
      <Modal
        show={true}
        onHide={() => this.props.closeModal()}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {product ? (
              `ID: ${product._id}`
            ) : (
              <FormattedMessage id="Add.Image" />
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {product ? (
            <>
              <Row className="text-center">
                <Col>
                  <Image width={250} src={currentImage} thumbnail alt="" />
                </Col>
              </Row>
              <Row>
                <Col className="text-center mt-3">
                  <MenuButton
                    icon="upload"
                    size="sm"
                    onClick={() => this.openImgModal(currentImage)}
                  >
                    <FormattedMessage id="Modify" />
                  </MenuButton>
                </Col>
              </Row>
            </>
          ) : (
            <FileDropZone
              onDropFile={(file) => this.setState({ file: file })}
              acceptedExtensions={["jpg", "png", "jpeg", "webp"]}
              multiple={false}
            />
          )}
          <Form className="mt-3">
            {/* <Form.Group>
              <Form.Label>
                <FormattedMessage id="Manufacturer" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.manufacturer}
                onChange={(e) =>
                  this.setState({ manufacturer: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Supplier" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.supplier}
                onChange={(e) => this.setState({ supplier: e.target.value })}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Designation" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.designation}
                onChange={(e) => this.setState({ designation: e.target.value })}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Description" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.description}
                onChange={(e) => this.setState({ description: e.target.value })}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Lpp.Code" />
              </Form.Label>
              <Form.Control
                type="text"
                value={this.state.lppCode}
                onChange={(e) => this.setState({ lppCode: e.target.value })}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Lpp.Amount" />
              </Form.Label>
              <Form.Control
                type="number"
                value={this.state.lppAmount}
                onChange={(e) => this.setState({ lppAmount: e.target.value })}
              />
            </Form.Group> */}

            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Ref" />
              </Form.Label>
              <Row>
                <Col md="10">
                  <Form.Control
                    type="text"
                    value={this.state.keyword}
                    isInvalid={this.state.keywordError !== ""}
                    onChange={(e) =>
                      this.setState({ keyword: e.target.value.toUpperCase() })
                    }
                    onBlur={() =>
                      this.isKeywordAlreadyExists(this.state.keyword)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.keywordError}
                  </Form.Control.Feedback>
                </Col>
                <Col md="2">
                  <Button
                    variant="info"
                    disabled={
                      this.state.keyword.trim() === "" ||
                      this.state.keywordError
                    }
                    onClick={() =>
                      this.state.keyword.trim() !== "" &&
                      this.state.keywordError === "" &&
                      this.addKeyword(this.state.keyword)
                    }
                  >
                    <Icon icon="circle-plus" />
                  </Button>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          <table className="table tablee4mad">
            <thead>
              <tr>
                <th className="col-10">
                  <FormattedMessage id="Refs" />
                </th>
                <th className="align-middle text-center tdaction">
                  <FormattedMessage id="Actions" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.keywords?.map((k, i) => (
                <tr key={i}>
                  <td className="col-10">{k}</td>
                  <td className="text-center">
                    <Button
                      variant="info"
                      onClick={() => this.openKeywordModal(k)}
                    >
                      <Icon icon="pen-to-square" />
                    </Button>
                    <Button
                      variant="danger"
                      className="ml-2"
                      disabled={this.state.keywords.length <= 1}
                      onClick={() =>
                        this.state.keywords.length > 1 &&
                        this.openConfModal(
                          <FormattedMessage id="Warning" />,
                          <FormattedMessage id="Remove.Ref.Confirmation" />,
                          () => this.deleteKeyword(k),
                        )
                      }
                    >
                      <Icon icon="trash" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <FileDropZone
            onDropFiles={(files) => this.onDropFiles(files)}
            acceptedExtensions={["pdf", "doc", "docx", "jpg", "png", "jpeg", "webp"]}
            multiple={true}
          /> */}

          {/* <table className="table tablee4mad">
            <thead>
              <tr>
                <th className="col-10">
                  <FormattedMessage id="Documents" />
                </th>
                <th className="align-middle text-center tdaction">
                  <FormattedMessage id="Actions" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.documents?.map((d, i) => (
                <tr key={i}>
                  <td className="col-10">
                    {d._id ? (
                      <a
                        role="button"
                        href={
                          APIUrl.getProductDocument +
                          d._id +
                          "?token=" +
                          APIUrl.jwtToken
                        }
                        rel="noopener noreferrer"
                        download={d.file_name}
                        target="_blank"
                      >
                        {d.file_name}
                      </a>
                    ) : (
                      d.file_name
                    )}
                  </td>
                  <td className="text-center">
                    <Button
                      variant="danger"
                      className="ml-2"
                      onClick={() =>
                        this.openConfModal(
                          <FormattedMessage id="Warning" />,
                          <FormattedMessage id="Remove.Document.Confirmation" />,
                          () => this.deleteDocument(d),
                        )
                      }
                    >
                      <Icon icon="trash" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table> */}
          {this.state.modal}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="info"
            disabled={
              this.state.keywords.length === 0 ||
              (!product && this.state.file === null) ||
              this.state.keywordError !== ""
            }
            onClick={() => this.addProduct()}
          >
            <FormattedMessage id={product ? "Save.Changes" : "Confirm"} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddProduct: (data, successCallback) =>
      dispatch(addProduct(data, successCallback)),
    onAddProductImage: (productId, data, successCallback) =>
      dispatch(addProductImage(productId, data, successCallback)),
    onAddProductDocuments: (productId, data, successCallback) =>
      dispatch(addProductDocuments(productId, data, successCallback)),
    onUpdateProduct: (data, successCallback) =>
      dispatch(updateProduct(data, successCallback)),
    onGetIsProductKeywordAlreadyExists: (
      keyword,
      existsCallback,
      noExistsCallback,
    ) =>
      dispatch(
        isProductKeywordAlreadyExists(
          keyword,
          existsCallback,
          noExistsCallback,
        ),
      ),
    onDeleteProductDocument: (documentId, successCallback) =>
      dispatch(deleteProductDocument(documentId, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ProductModal));
